export default __webpack_public_path__ + "static/media/a020-cs-4.cfe0d48f.svg";